<template>
    <e-mobile-modal v-model="languageSelectModal" :title="'Select Language|Choisir la langue' | tr">
        <b-list-group flush>
            <b-list-group-item v-for="lang in languages" :key="lang.locale" button @click="selectLocale(lang.locale)" :active="lang.locale === currentLocale" class="language-option interactive">
                <div class="d-flex align-items-center py-2">
                    <img v-if="showLanguageFlags && lang.flag" :src="lang.flag" class="flag-icon mr-3" />
                    <div class="flex-grow-1">
                        <div class="font-weight-bold">{{ lang.name }}</div>
                        <div class="small text-muted">{{ lang.locale.toUpperCase() }}</div>
                    </div>
                    <i v-if="lang.locale === currentLocale" class="fas fa-check text-success"></i>
                </div>
            </b-list-group-item>
        </b-list-group>
    </e-mobile-modal>
</template>

<script>
import { getSupportedLocales, setLocale, getLocale, normalizeLocaleCode } from '@vue-components/helpers/I18nPluginHelper.js';
import EMobileModal from './e-mobile-modal.vue';

export default {
    name: `modal-select-language`,
    components: { EMobileModal },
    computed: {
        currentLocale() {
            return getLocale();
        },
        languages() {
            const cmsLangs = this.cmsWebsite?.settings?.languages;
            if (!Array.isArray(cmsLangs) || !Array.isArray(getSupportedLocales())) return [];
            return getSupportedLocales().filter(opt => cmsLangs.includes(opt.locale));
        },
        showLanguageFlags() {
            return this.cmsWebsite?.settings?.languageModalShowFlags !== false;
        },
        languageSelectModal: {
            get() {
                return this.$store.state.languageSelectModal;
            },
            set(value) {
                this.$store.state.languageSelectModal = value;
            }
        }
    },
    methods: {
        async selectLocale(locale) {
            if (this.isEditMode) {
                return;
            }

            const previousLocale = getLocale();
            const normalized = normalizeLocaleCode(locale) || locale;
            if (normalized === previousLocale) {
                this.$store.state.languageSelectModal = false;
                return;
            }

            await setLocale(normalized);
            this.$store.state.previewLanguage = normalized;
            this.$store.state.languageSelectModal = false;
            window.location.reload();
        },
    }
}
</script>

<style lang="scss" scoped>
.language-option {
    transition: all 0.2s;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &.active {
        background-color: rgba(var(--primary-rgb), 0.1);
        color: rgba(0, 0, 0, 1);
    }
}

.flag-icon {
    width: 32px;
    height: 24px;
    object-fit: cover;
    border-radius: 2px;
}
</style>
